/**
*
* ColorSelect
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { components } from 'react-select';
import { useIntl } from 'react-intl';
import { string } from 'yup';
import classNames from 'classnames';
import ReactSelect from 'components/interaction/ReactSelect/index.jsx';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import messages from './messages.js';
import Blocks from './Blocks.jsx';
import { colors } from './constants.js';

const StyledSelect = styled(ReactSelect)`
  width: auto;
  .rs__control {
    min-width: 12em;
  }
  .color-block {
    margin-right: 0;
  }
`;

const withColorBox = (Component) => (props) => {
  // eslint-disable-next-line react/prop-types
  const { data } = props;
  // eslint-disable-next-line react/prop-types
  const { value, label } = data;
  return (
    <Component {...props}>
      <AvatarWithText color={value} align="center" group title={label}>{label}</AvatarWithText>
    </Component>
  );
};

function ColorSelect(props) {
  const { blocks, className, ...rest } = props;
  const intl = useIntl();
  const options = colors.map((clr) => ({
    value: clr.value,
    label: intl.formatMessage(messages[clr.id]),
  }));
  if (blocks) {
    return <Blocks options={options} {...rest} />;
  }
  const myComponents = {
    Option: withColorBox(components.Option),
    SingleValue: withColorBox(components.SingleValue),
  };
  const placeholder = intl.formatMessage(messages.header);
  const classList = classNames([className, 'form-control-unstyled']);

  return (
    <StyledSelect {...props} className={classList} large placeholder={placeholder} options={options} components={myComponents} />
  );
}

ColorSelect.propTypes = {
  blocks: PropTypes.bool,
  className: PropTypes.string,
};

ColorSelect.getSchema = () => string();

export default ColorSelect;
